module.exports = __webpack_public_path__ + "static/img/tu1.2e09315e.png";